import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";

function ConclusionPage() {
  return (
    <ContentOverlay
      heading={
        <h2
          style={{
            textAlign: "center",
            fontFamily: "Nunito",
          }}
        >
          {" "}
          <b>Conclusion</b>
        </h2>
      }
      text_content={
        <div>
          <p
            className="container"
            style={{
              fontSize: "0.8em",
              fontFamily: "Nunito",
            }}
          >
            <p>
              Land use dynamics (from 1973 to 2021), along with quantification
              of carbon in Chikamagaluru district and climate variability, have
              been done to understand likely climatic trends in the district.
              Land use analyses showed a decline in forest cover of 28.98%, an
              increase in agricultural area by 5.31%, and horticulture by
              42.52%. Assessment of the forest structure through fragmentation
              metrics reveals a decrease in intact forests from 55.72% (1973) to
              28.05% (2021). Globalization and liberalization in 1990&rsquo;s
              had given impetus to rapid land use changes with the conversion of
              forest lands into agricultural, horticultural, and built-up areas
              to meet the needs of the expanding human population, which has
              caused an imbalance in the ecological structure of the region.
              Carbon assessment from 1973 to 2021 also showed a declining carbon
              stock (soil, dead biomass, above ground, and below ground
              biomass), which led to a decrease in carbon by 30683.81 Gg from
              1973 to 2021. The analyses reveal that the continuation of trends
              in land degradation and associated native forests loss would
              impact the carbon sequestration capability of ecosystems to
              mitigate changes in the climate with the global warming. Long-term
              climatic trend analyses show the study region will experience an
              increase in temperature (&lt; 0.5&deg;C), an increase in rainfall
              (up to 100 mm), and rainy days (2 to 4 days). The analyses of
              landscape cover dynamics with climatic variability demonstrate
              that land cover in the Western Ghats landscape have played a
              critical role in moderating microclimatic conditions and
              continuance of land degradation with deforestation would have
              serious implications on the climate with higher temperature,
              alterations in the rainfall and rainy days, which will have
              serious implications on the livelihood of people with increase in
              vector-borne disease (increase in temperature) and recurring
              instances of landslides and mudslides due to flooding with changes
              in the rainfall pattern.
            </p>
            <p>
              This study emphasizes the necessity for sustainable development
              measures and forest restoration policies to protect the
              ecologically fragile ecosystem in the study region to maintain the
              carbon sinks. This would also aid in the sustainment of
              hydrological and other ecological cycles. Proper policy
              measurements will help the local community to reach the
              sustainable goal of zero poverty and equal livelihood
              opportunities.
            </p>

            <br />
            <br />
            <hr />
            <br />
          </p>
        </div>
      }
    />
  );
}
export default ConclusionPage;
